import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import type { Period } from 'lumen/models';

import styles from './td-date-month.module.css';

interface HotelPricingAssistantTableCellsTdDateMonthSignature {
  Args: {
    value: Period;
  };
}

export default class HotelPricingAssistantTableCellsTdDateMonth extends Component<HotelPricingAssistantTableCellsTdDateMonthSignature> {
  @service declare dates: Services['dates'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  get formattedDate(): string {
    return this.args.value.fromDate.format(
      this.dates.partialDateFormat.WEEKDAY_AND_MONTH_AND_DAY_SHORT,
    );
  }

  get isPast(): boolean {
    return this.hotelAndMarketService.isPast(this.args.value.fromDate);
  }

  get isToday(): boolean {
    return this.args.value.fromDate.isSame(
      this.hotelAndMarketService.getLocalTime(),
      'day',
    );
  }

  <template>
    <p
      aria-current={{if this.isToday "date"}}
      class="{{if this.isToday 'text-300--bold' 'text-300--medium'}}
        {{if this.isPast 'text-disabled'}}
        {{if this.isToday styles.today-date}}"
      data-test-id="date-month-cell"
    >
      {{this.formattedDate}}
    </p>
  </template>
}
